import React from 'react';
import { getActiveIcon } from 'library/helpers';
import { formatDateTime } from 'library/time';
import { formatTravelLeg, formatTravelLegList } from 'selectors/travel.selectors';
import { THEME_NAMES } from 'selectors/tag.selectors';
import { AuditHistory } from 'components/Audit';
import { DocLink, DocPages } from 'components/Help/';
import { CanViewTravel } from 'library/permissions';
import LegFormInput from './input';

const config = {
  init: {
    active: true
  },
  // List Table
  list: {
    // Table Columns
    format: formatTravelLegList,
    columns: [
      {
        title: 'Reference',
        dataIndex: 'reference_number',
        width: '130px',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Carrier',
        dataIndex: 'carrier',
        sorter: true
      },
      {
        title: 'Route',
        dataIndex: 'route__name',
        width: '130px',
        sorter: true,
        render: (text, record) => record.route.name
      },
      {
        title: 'Departure Time',
        dataIndex: 'departure_time',
        width: '140px',
        align: 'center',
        sorter: true,
        render: (text, record) => formatDateTime(record.departure_time, 'HH:mm')
      },
      {
        title: 'Arrival Time',
        dataIndex: 'arrival_time',
        width: '140px',
        align: 'center',
        sorter: true,
        render: (text, record) => formatDateTime(record.arrival_time, 'HH:mm')
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '110px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [{
          text: 'Active',
          value: true
        }, {
          text: 'Inactive',
          value: false
        }],
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the leg
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'reference_number',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      reference_number: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['reference_number'],
        searchValue: ''
      },
      carrier: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['carrier'],
        searchValue: ''
      },
      route__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['route__name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.travelLegs}>Legs</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    format: formatTravelLeg,
    emptyMessage: 'Please select a Leg',
    title: 'Leg',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <LegFormInput
            {...props}
            title="Leg"
          />
        )
      },
      {
        key: 1,
        title: 'History',
        component: props => (
          <AuditHistory
            {...props}
            themeName={THEME_NAMES.leg}
          />
        ),
        show: () => CanViewTravel()
          .hasPermissions()
      }
    ]
  }
};

export default config;
